import { createAction, props } from '@ngrx/store';

import {
  CalculationBenefitWarningsParams,
  CreateGenerateCalculationWorksheetRequest,
  CreateGenerateCalculationWorksheetResponse,
  GetBankConfigurationResponse,
  GetCalculationBenefitDetailsRequest,
  GetCalculationBenefitDetailsResponse,
  GetListEmployerTypesRequest,
  GetListEmployerTypesResponse,
  SetBenefitDetailParams,
  SetBenefitDetailRequest,
} from '../../services/models';

export const getCalculationBenefitDetailsAction = createAction(
  '[GetCalculationBenefitDetails/API] Send Request',
  props<{ request: GetCalculationBenefitDetailsRequest }>(),
);

export const getCalculationBenefitDetailsSuccessAction = createAction(
  '[GetCalculationBenefitDetails/API] Success',
  props<{ response: GetCalculationBenefitDetailsResponse }>(),
);

export const getCalculationBenefitDetailsFailureAction = createAction(
  '[GetCalculationBenefitDetails/API] Failure',
  props<{ error?: any }>(),
);

export const clearGetCalculationBenefitDetailsStateAction = createAction('[GetCalculationBenefitDetails] Clear');

export const setBenefitDetailAction = createAction(
  '[SetBenefitDetail/API] Send Request',
  props<{ params: SetBenefitDetailParams; request: SetBenefitDetailRequest; editItem: string }>(),
);

export const setBenefitDetailSuccessAction = createAction(
  '[SetBenefitDetail/API] Success',
  props<{ editItem: string }>(),
);

export const setBenefitDetailFailureAction = createAction(
  '[SetBenefitDetail/API] Failure',
  props<{ error?: any; editItem: string }>(),
);

export const clearSetBenefitDetailStateAction = createAction('[SetBenefitDetail] Clear');

export const closeBenefitWarningMessageAction = createAction(
  '[CloseBenefitWarningMessage/API] Send Request',
  props<{ params: CalculationBenefitWarningsParams }>(),
);

export const closeBenefitWarningMessageSuccessAction = createAction('[CloseBenefitWarningMessage/API] Success');

export const closeBenefitWarningMessageFailureAction = createAction(
  '[CloseBenefitWarningMessage/API] Failure',
  props<{ error?: any }>(),
);

export const clearCloseBenefitWarningMessageStateAction = createAction('[CloseBenefitWarningMessage] Clear');

export const createGenerateCalculationWorksheetAction = createAction(
  '[CreateGenerateCalculationWorksheet/API] Send Request',
  props<{ memberId: string, request: CreateGenerateCalculationWorksheetRequest }>()
);

export const createGenerateCalculationWorksheetSuccessAction = createAction(
  '[CreateGenerateCalculationWorksheet/API] Success',
  props<{ response: CreateGenerateCalculationWorksheetResponse }>()
);

export const createGenerateCalculationWorksheetFailureAction = createAction(
  '[CreateGenerateCalculationWorksheet/API] Failure',
  props<{ error?: any }>(),
);

export const clearCreateGenerateCalculationWorksheetStateAction = createAction(
  '[CreateGenerateCalculationWorksheet] Clear',
);

export const getListEmployerTypesAction = createAction(
  '[GetListEmployerTypes/API] Send Request',
  props<{ request: GetListEmployerTypesRequest }>(),
);

export const getListEmployerTypesSuccessAction = createAction(
  '[GetListEmployerTypes/API] Success',
  props<{ response: GetListEmployerTypesResponse }>(),
);

export const getListEmployerTypesFailureAction = createAction(
  '[GetListEmployerTypes/API] Failure',
  props<{ error?: any }>(),
);

export const clearGetListEmployerTypesStateAction = createAction('[GetListEmployerTypes] Clear');

export const getBankConfigurationAction = createAction(
  '[GetBankConfiguration/API] Send Request',
);

export const getBankConfigurationSuccessAction = createAction(
  '[GetBankConfiguration/API] Success',
  props<{ response: GetBankConfigurationResponse }>()
);

export const getBankConfigurationFailureAction = createAction(
  '[GetBankConfiguration/API] Failure',
  props<{ error?: any }>()
);

export const clearGetBankConfigurationStateAction = createAction(
  '[GetBankConfiguration] Clear'
);

